import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../config/constants';

const BottomText = styled.p`
  margin-top: 30px;
  font-size: 10px;
`;

const ScreenContainer = styled.div`
  padding-top: 90px;
`;

const BoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 60vw;
  padding: 5vw;
  margin: auto;
  padding-bottom: 1vw;
  min-height: fit-content;
  background-color: ${colors.COLOR_GRAY}
`;

const BaconStopContainer = styled.div`
  width: 100%;
  flex-direction: column;
  img {
    max-width: 250px;
  }
  align-items: center;
  padding-left: 2vw;
  margin-top: 10px;
`;

const BaconLogoContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  img {
    max-width: 150px;
  }
  p {
    font-size: 1.3em;
  }
  margin-bottom: -10px;
`;

const LoginHeading = styled.h1`
  font-family: LexiaAd;
  font-size: 3em;
  margin: 0px;
  margin-bottom: -10px;
  padding: 0px;
  color: ${colors.COLOR_WHITE}
`;

const ButtonContainer = styled.div`
  margin: auto;
`;

const InputsContainer = styled.div`
  margin: auto;
  padding-top: 20px;
  margin-bottom: -10px;
`;

const ErrorContainer = styled.div`
  margin-top: 10px;
  margin-bottom: -5px;
`;

//eslint-disable-next-line
const Box = ({ children, status, bottomText }) => {

  const LogoContainer = status === 'error' ? BaconStopContainer : BaconLogoContainer;
  const logo = status === 'error' ? 'bacon_stop.svg' : 'bacon_icon.svg';
  
  return (
    <ScreenContainer>
      <BoxContainer>
        <LogoContainer>
          <img
            src={`${process.env.PUBLIC_URL}/images/${logo}`}
            alt="Bacon logo"
          />
        </LogoContainer>
        {children}
        <BottomText>{bottomText}</BottomText>
      </BoxContainer>
    </ScreenContainer>
  );
};

export {Box, LoginHeading, InputsContainer, ErrorContainer, ButtonContainer};